import { createSlice } from '@reduxjs/toolkit';

type RubricaTotal = {
	totalRespuestas: number;
	totalDimensiones: number;
	completo: boolean;
	isObligatoria: boolean;
};

type RubricaTotalesState = {
	[key: string]: RubricaTotal;
};

const initialState: RubricaTotalesState = {};

const rubricaTotalesSlice = createSlice({
	name: 'rubricaTotales',
	initialState,
	reducers: {
		setTotales: (state, action) => {
			const { key, totalRespuestas, totalDimensiones, completo, isObligatoria } = action.payload;
			return {
				...state,
				[key]: { totalRespuestas, totalDimensiones, completo, isObligatoria }
			};
		},
		resetTotales: (state) => {
			return initialState;
		},
		cleanTotales: (state, action) => {
			const validKeys = action.payload;
			const newState: RubricaTotalesState = {};
			Object.keys(state).forEach((key) => {
				if (validKeys.some((validKey: string) => key.startsWith(validKey))) {
					newState[key] = state[key];
				}
			});
			return newState;
		}
	}
});

export const { setTotales, resetTotales, cleanTotales } = rubricaTotalesSlice.actions;
export default rubricaTotalesSlice.reducer;
